import { render, staticRenderFns } from "./modalOpenFest.vue?vue&type=template&id=636aef50&"
import script from "./modalOpenFest.vue?vue&type=script&lang=js&"
export * from "./modalOpenFest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports